module.exports = __webpack_public_path__ + "static/media/CTLA_3-286w.99ef6096.jpg";